import React from "react";
import { Link } from "react-router-dom";
import "@/landing.css";

export function MarketingNav() {
  return (
    <nav className="mkt-nav">
      <Link to="/" className="mkt-logo" data-testid="landing-logo">
        <img src="/brand/icon-gold.png" alt="Viral Book Suite" className="mkt-logo-img" />
        <span className="mkt-logo-text">
          Viral<span>BookSuite</span>
        </span>
      </Link>
    </nav>
  );
}

export function MarketingFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mkt-footer mkt-footer-slim" data-testid="marketing-footer">
      <div className="mkt-footer-inner">
        <div className="mkt-footer-bottom">
          <Link to="/" className="mkt-footer-logo">
            <img src="/brand/icon-gold.png" alt="" className="mkt-footer-logo-img" />
            <span>
              Viral<span className="light">BookSuite</span>
            </span>
          </Link>
          <nav className="mkt-footer-links" aria-label="footer navigation">
            <Link to="/stripe-signin" data-testid="footer-login-link">Login</Link>
            <a
              href="https://www.theevergreenroyalties.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-newsletter-link"
            >
              Join Newsletter
            </a>
            <a href="mailto:hello@viralbooksuite.com" data-testid="footer-email-link">hello@viralbooksuite.com</a>
            <Link to="/privacy" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link">Terms</Link>
          </nav>
        </div>

        {/* Legal + earnings disclaimer */}
        <div className="mkt-footer-legal" data-testid="footer-legal">
          <p className="mkt-footer-copy" data-testid="footer-copyright">
            © <span data-testid="footer-year">{year}</span> ViralBookSuite.com. All Rights Reserved.
          </p>
          <p className="mkt-footer-amazon">
            This site is not part of Amazon.com or endorsed by Amazon in any way.
          </p>
          <p className="mkt-footer-disclaimer">
            <strong>Earnings Disclaimer:</strong> Results stated above are personal results and those of top students. Results are not typical. Your results will vary and depend on many factors including your niche, consistency, and work ethic.
          </p>
          <p className="mkt-footer-disclaimer">
            The average person who buys any "how to" product gets little to no results when they don't put in the work, time and effort required to get result. This is in no way a get rich quick scheme.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default function MarketingShell({ children }) {
  return (
    <div className="mkt-root">
      <MarketingNav />
      {children}
      <MarketingFooter />
    </div>
  );
}
